export default __webpack_public_path__ + "static/media/drink-right.3c2ba37c.png";